export const PAYMENT_METHODS = [
  { value: 'ACH', label: 'ACH' },
  { value: 'CHECK', label: 'Paper Check' },
];
